import React from "react";

const Workforce = () => {
  return <div>Workforce</div>;
};

export default Workforce;
